import { POSTAL_CHANNEL_DXP_SAFETYLABEL, POSTAL_TOPIC_SAFETYLABEL_SHOW } from "../constants";
import { postalPublish } from "./postalUtils";

export const triggerShowSafetyLabel = (): void => {
    postalPublish({
        channel: POSTAL_CHANNEL_DXP_SAFETYLABEL,
        topic: POSTAL_TOPIC_SAFETYLABEL_SHOW,
    });
};
